export default __webpack_public_path__ + "static/media/email.a2a101f7.svg";